module.exports = __webpack_public_path__ + "static/cat_4-6fc5455c2e968533f1492654881ee0aa.png";